<template>
  <div>
    <!-- <div style="word-break: break-all; white-space: pre-wrap;">{{pictureModal}}</div> -->
    <customPicture1
      :ref="'customPicture' + index"
      :index="index"
      :commmonType="type"
      @close="close"
      @add="add"
      v-model="pictureModal"
      @closeModel="$emit('closeModel', $event)"
    ></customPicture1>
  </div>
</template>

<script>
import customPicture1 from "@components/custom-component/common/custom-picture/components/custom-picture-type-1.vue";
export default {
  // 文本类型 1
  name: "custom-picture",
  model: {
    prop: "pictureModal",
    event: "sendPictureModal"
  },
  props: {
    pictureModal: {
      type: Object,
      default: function() {
        return {
          type: 1, // 文本类型 1 = （list 列表形式） 2 =  (swiper 轮播模式)
          padding: 0, // 页面边距
          spacing: 0, // 图片边距
          list: []
        };
      }
    },
    index: {
      type: Number,
      default: 0
    }, 
    type: { // 通用添加组件的列表   1：所有列表   2：筛选列表
      type: Number,
      default: 1,
    }
  },
  data() {
    return {};
  },
  components: {
    customPicture1
  },
  methods: {
    close() {
      this.$emit("close");
    },
    add(item, idx) {
      this.$emit("add", item, idx);
    },
  }
};
</script>

<style scoped lang="scss">
</style>
